import {Helmet} from '@dr.pogodin/react-helmet';
import {isFeatureEnabled} from 'feature-flags';
import {Action} from 'platform/components';
import {Show} from 'platform/foundation';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {customerRoutes, testIds} from '@dms/routes';
import {Main, PageTab, usePermissions} from '@dms/shared';

import {buildArray, useNavigate} from 'shared/web';

import {CustomersOverview} from './(sections)/CustomersOverview/CustomersOverview';
import {GdprConsentsOverview} from './(sections)/GdprConsentsOverview/GdprConsentsOverview';

export function CustomerOverview() {
  const navigate = useNavigate();

  const [canReadGdprConsent] = usePermissions({
    permissionKeys: ['readGdprConsentDocument'],
    scopes: {
      readGdprConsentDocument: {
        // Customer has no branchId
        branchId: 'SKIP',
      },
    },
  });

  const isGdprTabVisible = isFeatureEnabled(featureFlags.CORE_GDPR_DATAGRID) && canReadGdprConsent;

  const tabs = buildArray<PageTab>()
    .add({
      id: 'customers',
      title: i18n.t('page.customers.title'),
      href: customerRoutes.overview,
      content: <CustomersOverview />,
    })
    .when(isGdprTabVisible, {
      id: 'gdprConsents',
      title: i18n.t('entity.customer.labels.GDPRConsents'),
      href: customerRoutes.gdprConsentsOverview,
      content: <GdprConsentsOverview />,
    });

  const actions: Action[] = [
    {
      type: 'button',
      onClick: () => navigate(customerRoutes.create),
      variant: 'primary',
      'data-testid': testIds.customer.overview('create'),
      title: i18n.t('entity.customer.actions.newCustomer'),
    },
  ];

  return (
    <>
      <Helmet title={i18n.t('page.customers.title')} />
      <Main
        isFullHeight
        actions={actions}
        tabs={isGdprTabVisible ? tabs : undefined}
        data-testid={testIds.customer.overview('container')}
      >
        <Show when={!isGdprTabVisible}>
          <CustomersOverview />
        </Show>
      </Main>
    </>
  );
}
